import { render, staticRenderFns } from "./CouponShopPoolDetailTable.vue?vue&type=template&id=06b810b4&scoped=true"
import script from "./CouponShopPoolDetailTable.vue?vue&type=script&lang=js"
export * from "./CouponShopPoolDetailTable.vue?vue&type=script&lang=js"
import style0 from "./CouponShopPoolDetailTable.vue?vue&type=style&index=0&id=06b810b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b810b4",
  null
  
)

export default component.exports